//
import Card from './Card';
import Paper from './Paper';
import Table from './Table';

// ----------------------------------------------------------------------

export default Object.assign({ ...Card, ...Paper, ...Table }, {});
